import { TextPresetNames } from './types';
export const FALLBACK_COLOR_TO_SITE_COLOR_MAPPING = {
  emptyPlayIconEditor: 'color-4',
  emptyPlayIconSite: 'color-1',
  emptyPlayerBgEditor: 'color-2',
  emptyPlayerBgSite: 'color-2',
  backgroundColor: 'color-1',
  buttonsAndLinksColor: 'color-8',
  mainButtonTextColor: 'color-1',
  textColor: 'color-5',
  dividersAndArrowsColor: 'color-3',
  mobileButtonsTextColor: 'color-1',
  mobileButtonsBackgroundColor: 'color-8',
  mainButtonColor: 'color-8'
};
export const FALLBACK_FONT_TO_TEXT_PRESET_MAPPING = {
  textFont: TextPresetNames.BodyM,
  titleFont: TextPresetNames.HeadingL,
  videoInfoFont: TextPresetNames.HeadingS
};
export const FALLBACK_FONT_TO_TEXT_PRESET_MAPPING_RESPONSIVE = {
  textFont: TextPresetNames.BodyM,
  titleFont: TextPresetNames.Title,
  videoInfoFont: TextPresetNames.HeadingS
};
export const DEFAULT_ADI_CHANNEL = '9bf7ba3816de4423963e7d6e23c072e0';
//# sourceMappingURL=constants.js.map